module.exports = __webpack_public_path__ + "img/xyb.71e99217.jpg";